import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@upsales/components';
export default class View extends React.Component {
	constructor(props) {
		super(props);

		var t = Tools.$translate;
		this.lang = {
			view: t('default.show'),
			goToAccount: t('default.goToAccount')
		};

		this.goToAccount = this.goToAccount.bind(this);
	}

	goToAccount() {
		this.props.actions.goToAccount(this.props.account.id);
	}

	render() {
		var button = (
			<span>
				<Button type="link" color="bright-blue" onClick={this.goToAccount}>
					{this.lang.view}
				</Button>
			</span>
		);

		const hasGroupTreeVirtualizedList = Tools.FeatureHelper.hasSoftDeployAccess('GROUP_TREE_VIRTUALIZED_LIST');
		const Component = hasGroupTreeVirtualizedList && !this.props.createNewAccountRow ? 'div' : 'td';
		return (
			<Component
				className={`DataSourceColumn view-column ${
					hasGroupTreeVirtualizedList && !this.props.createNewAccountRow ? 'align-items-center' : ''
				}`}
			>
				<Tooltip title={this.lang.goToAccount} position="left" key={this.props.account.id}>
					{button}
				</Tooltip>
			</Component>
		);
	}
}

View.propTypes = {
	actions: PropTypes.object,
	account: PropTypes.object,
	createNewAccountRow: PropTypes.bool
};
